import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myPart2 } from "@/lib/api";
import { pick, fmtDate, canOpenDay } from "@/pages/participant/part2Util";

export default function Part2HubSection() {
  const { user, lang } = useApp();
  const t = useAppUi(lang);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!user) { setData(null); return; }
    myPart2().then(setData).catch(() => setData(null));
  }, [user]);
  if (!data?.access) return null;
  return (
    <div className="rbl-wrap" style={{ paddingBottom: 40 }} data-testid="hub-part2">
      <h2 className="rbl-section-title">{t("p2Title")}</h2>
      <p className="rbl-intro" style={{ marginTop: -6, marginBottom: 18 }}>{t("p2Intro")}</p>
      <div className="rbl-grid">
        {data.days.map((d, i) => {
          const open = canOpenDay(d.day_number, user.role);
          const Tag = open ? Link : "div";
          return (
            <Tag to={open ? `/app/part2/${d.day_number}` : undefined} key={d.day_number} className={`rbl-card ${open ? "" : "locked"}`} data-testid={`hub-part2-day-${d.day_number}`}>
              <span className="rbl-card-num">{t("dayLabel").toUpperCase()} {String(d.day_number).padStart(2, "0")}</span>
              <span className="rbl-card-title">{pick(d.title, lang)}</span>
              <span className="rbl-card-meta">{pick(d.subtitle, lang)}</span>
              <span className="rbl-card-meta" style={{ marginTop: 6 }}>🕘 {d.hours}{data.dates?.[i] ? ` · ${fmtDate(data.dates[i], lang)}` : ""}</span>
              <span className="rbl-card-cta">{open ? `${t("openDay")} →` : `🔒 ${t("lockedSoon")}`}</span>
            </Tag>
          );
        })}
      </div>
    </div>
  );
}
